module.exports = __webpack_public_path__ + "media/images/signatures/maria_mendieta-2f3e401739fe5a8b10a230486b8a92aaf99a3d13701ba06bab10f4a8577bfec7.png";